import React from 'react';
import { Scale, AlertOctagon } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const costs = [{
  sin: 'Service cada vez que algo falla',
  costo: '$15.000-30.000 ARS por visita'
}, {
  sin: 'Presión incorrecta en el neumático',
  costo: 'Rulemanes que duran 2.000 km en vez de 10.000'
}, {
  sin: 'Hábitos de carga incorrectos',
  costo: 'Pack que dura 700 ciclos en vez de 1.500'
}, {
  sin: 'Tornillo de pedal suelto en marcha',
  costo: 'Una caída que ningún casco compensa completamente'
}, {
  sin: 'Rodar con error activo',
  costo: 'Falla grave en el momento menos oportuno'
}];
export function CostComparison() {
  return <AnimatedSection className="py-24 bg-brand-surface border-y border-brand-border" data-id="element-39">
      <div className="container mx-auto px-4 md:px-6" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          <div className="text-center mb-12" data-id="element-42">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-43">
              <Scale className="w-8 h-8 text-brand-yellow" data-id="element-44" />
              ¿Cuánto cuesta NO tenerlo?
            </h2>
          </div>

          <div className="bg-brand-dark border border-brand-border rounded-xl overflow-hidden mb-12" data-id="element-45">
            <div className="grid grid-cols-1 md:grid-cols-2 bg-zinc-900 border-b border-brand-border hidden md:grid" data-id="element-46">
              <div className="p-6 font-bold text-zinc-400" data-id="element-47">Sin Mega Pack</div>
              <div className="p-6 font-bold text-red-400" data-id="element-48">Costo real</div>
            </div>

            <div className="divide-y divide-brand-border" data-id="element-49">
              {costs.map((item, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-2" data-id="element-50">
                  <div className="p-4 md:p-6 text-zinc-300 md:border-r border-brand-border bg-brand-surface/30" data-id="element-51">
                    <span className="md:hidden font-bold text-zinc-500 block mb-1 text-xs uppercase" data-id="element-52">
                      Sin Mega Pack
                    </span>
                    {item.sin}
                  </div>
                  <div className="p-4 md:p-6 text-red-400 font-medium flex items-start gap-2" data-id="element-53">
                    <span className="md:hidden font-bold text-red-900/50 block mb-1 text-xs uppercase" data-id="element-54">
                      Costo real
                    </span>
                    <AlertOctagon className="w-5 h-5 shrink-0 mt-0.5 hidden md:block" data-id="element-55" />
                    {item.costo}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="text-center" data-id="element-56">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white inline-block border-b-2 border-brand-yellow pb-2" data-id="element-57">
              El próximo lunes puede ser diferente.
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}